import { render, staticRenderFns } from "./baoming_mng.vue?vue&type=template&id=0808452a&scoped=true&"
import script from "./baoming_mng.vue?vue&type=script&lang=js&"
export * from "./baoming_mng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808452a",
  null
  
)

export default component.exports